
export const setTokens = (tokens) => {
  localStorage.setItem("pimsWebAdmin", tokens.token);
}

export const setTokenOnly = (token) => {
  localStorage.setItem("pimsWebAdmin", token);
}

export const getToken = () => {
  return (localStorage.getItem("pimsWebAdmin"));
}

export const clearTokens = () => {
  localStorage.removeItem("pimsWebAdmin");
}

